import { store } from '../state/store'
import type { ActionResponse } from '../DTOs/Common/ErrorResponse'
import i18n from '../i18n'

export const mayQueueOffline = () => store.getState().authReducer.user?.canSyncOffline !== false

export const offlineRefusal = (): ActionResponse<null> => ({
  success: false,
  data: null,
  errors: [{ code: 0, description: i18n.t('offline.needsConnection') }],
})
